import { Component, Input, OnInit } from '@angular/core';
import { Member } from 'src/app/models/member.model';
import { Vestiging } from 'src/app/models/vestiging.model';

@Component({
  selector: 'app-member-card',
  templateUrl: './member-card.component.html',
  styleUrls: ['./member-card.component.sass']
})
export class MemberCardComponent implements OnInit {

  @Input() member:Member = new Member;
  @Input() details:Boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

  parseVestiging(member:any): string {
    if(!member.vestigingen) return "";
    return member.vestigingen.map((c:Vestiging) => c.naam).join(", ");
  }

}
